export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11603.06d3fef8.jpg";